import { AxiosPromise } from 'axios';
import Http from '../../shared/http';
import { ServerResponse } from '../types';
import {
  API_PATH_EXPORT_LOGS,
  API_PATH_LOGS,
  AuditActionDTO
} from './user-audit.types';

const http = Http.getHttp();

export function getAllUserAuditLogs(
  body: string
): AxiosPromise<ServerResponse<AuditActionDTO>> {
  return http.get(`${API_PATH_LOGS}?${body}`);
}

export function exportLogs(body: string): AxiosPromise<BlobPart> {
  return http.post(`${API_PATH_EXPORT_LOGS}?${body}`, {
    responseType: 'blob'
  });
}
